import HttpService from './HttpService';


export const LoadProfile = () => {
    const http = new HttpService();
    let profileUrl = "users/view-profile";
    const tokenId = "user-token";
    
    return http.getData(profileUrl, tokenId).then(data => {
       
         return data;
    }).catch((error) => {
        
         return error; 
    });
}
export const LoadProfileAxios = () => {
    const http = new HttpService();
    let profileUrl = "users/view-profile";
    const tokenId = "user-token";

    return http.getDataAxios(profileUrl, tokenId).then(data => {
        return data;
    }).catch((error) => {
        
        return error;
    });
}

export const LoadDecision = (signal) => {
    const http = new HttpService();
    let profileUrl = "users/state";
    const tokenId = "user-token";

    return http.getData(profileUrl, tokenId, signal).then(data => {

        return data;
    }).catch((error) => {
        
        return error;
    });
}


export const LoadUsersList = (signal) => {
    const http = new HttpService();
    let url = "users/users-list";
    const tokenId = "user-token";
    return http.getDataBySignal(url, tokenId,signal).then(data => {
         return data;
    }).catch((error) => {
        
         return error; 
    });
}
export const LoadCustomersList = (signal) => {
    const http = new HttpService();
    let url = "users/customers-list";
    const tokenId = "user-token";
    return http.getDataBySignal(url, tokenId, signal).then(data => {
        return data;
    }).catch((error) => {
        
        return error;
    });
}


export const UserDeleteService = (credentials) => {
    const http = new HttpService();
    let loginUrl = "users/user-delete";
    const tokenId = "user-token";
    return http.postData(credentials, loginUrl,tokenId).then((data) => {
        return data;
    }).catch((error) => {
        return error;;
    })
}
export const CustomerDeleteService = (credentials) => {
    const http = new HttpService();
    let loginUrl = "users/customer-delete";
    const tokenId = "user-token";
    return http.postData(credentials, loginUrl, tokenId).then((data) => {
        return data;
    }).catch((error) => {
        return error;;
    })
}

export const UpdateUserService = (credentials) => {
    const http = new HttpService();
    let loginUrl = "users/update-user";
    const tokenId = "user-token";
    return http.postData(credentials, loginUrl,tokenId).then((data) => {
        return data;
    }).catch((error) => {
        return error;;
    })
}
export const UpdateCustomerService = (credentials) => {
    const http = new HttpService();
    let loginUrl = "users/update-customer";
    const tokenId = "user-token";
    return http.postData(credentials, loginUrl, tokenId).then((data) => {
        return data;
    }).catch((error) => {
        return error;;
    })
}